import axios from "axios";
import { useRef, useState } from "react";
import "./login.css";
import { loginFailure, loginStart, loginSuccess } from "../../redux/userRedux";
import { publicRequest } from "../../requestMethod";
import { useDispatch, useSelector } from "react-redux";


export default function Login() {

  const emailRef = useRef();
  const passwordRef = useRef();
  // const {dispatch, isFetching} = useContext(Context);
  const dispatch = useDispatch();
  const { isFetching, error } = useSelector((state) => state.user);

  const [err, setErr] = useState("")

  const handleSubmit = async (e) => {
    e.preventDefault();
    // dispatch({type:"LOGIN_START"});
    // dispatch(loginStart());

    try {
      const res = await publicRequest.post("Account/SignIn", {
        email: emailRef.current.value,
        password: passwordRef.current.value
      });
      if (res.data.status) {
        //res.data && window.location.replace("/dashboard");
        dispatch(loginSuccess(res.data));
      }
      else {
        setErr(res.data.response)
      }
      // const res = await axios.post(baseUrl+"Account/SignIn", {
      //   email: emailRef.current.value,
      //   password: passwordRef.current.value
      // });
      // if(res.data.status){
      //   res.data && window.location.replace("/dashboard");
      //   dispatch({type:"LOGIN_SUCCESS",payload:res.data});
      // }
      // else{
      //   setErr(res.data.response)
      // }

    } catch (error) {
      setErr("Email / Password is wrong or check your internet connection")
      dispatch(loginFailure());
    }
  }
  return (
    <section className="vh-100 mt-5">
      <div className="container-fluid h-custom">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-md-9 col-lg-6 col-xl-5">
            <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp" className="img-fluid" alt="" />
          </div>
          <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
            {err && <p style={{ color: "red" }}>{err}</p>}
            <form className="mt-3" onSubmit={handleSubmit}>


              <div className="form-outline mb-4">
                <input type="email" id="form3Example3" className="form-control form-control-lg"
                  placeholder="Enter a valid email address" ref={emailRef} />
              </div>


              <div className="form-outline mb-3">
                <input type="password" id="form3Example4" className="form-control form-control-lg"
                  placeholder="Enter password" ref={passwordRef} />
              </div>

              <div className="d-flex justify-content-between align-items-center">

                <a href="#!" className="text-body">Forgot password?</a>
              </div>

              <div className="text-center text-lg-start mt-4 pt-2">
                <button type="submit" className="btn btn-primary btn-lg loginButton"
                  disabled={isFetching}>Login</button>
                <p className="small fw-bold mt-2 pt-1 mb-0">Don't have an account? <a href="/register"
                  className="link-danger">Register</a></p>
              </div>

            </form>
          </div>
        </div>
      </div>

    </section>
  )
}
